import React from 'react';
import styles from './RecipeContentTips.module.scss';
import { KitchenTip, RecipeResponse } from 'lib/services/models/content-response';
import EnhancedRichText from 'components/helpers/Atoms/EnhancedRichText/EnhancedRichText';
import useDictionary from 'lib/hooks/useDictionary';
import { SiteSettings } from 'lib/page-props-factory/plugins/site-settings';
import { filterRecipeTipsByExcludedCategories } from './RecipeContentTips.utils';
import { Data } from '@generated/Foundation.GMI.model';

export interface RecipeContentTipsProps {
  recipe?: RecipeResponse;
  recipeTips?: KitchenTip[];
  siteSettings?:
    | (SiteSettings & {
        recipeDetailSiteSettings?: Data.Settings.RecipeDetailSiteSettings;
      })
    | null;
}

export function RecipeContentTips(props: RecipeContentTipsProps) {
  const { recipeTips, siteSettings } = props;
  const { getDictionaryValue } = useDictionary();
  const header = getDictionaryValue('Components.Recipe.RecipeContentTips.Header') || 'Recipe Tips';

  // Filter tips using the utility
  const filteredTips = recipeTips
    ? filterRecipeTipsByExcludedCategories(recipeTips, siteSettings ?? null)
    : [];

  if (!filteredTips || filteredTips.length === 0) {
    return null;
  }

  return (
    <div className={styles.recipeTips}>
      <h2 className={styles.header}>{header}</h2>
      <ol className={styles.recipeTipsList}>
        {filteredTips.map((tip, index) => (
          <li key={index} className={styles.tipItem}>
            {/* <h3>{tip.Category}</h3> */}
            <EnhancedRichText value={tip.Description} />
          </li>
        ))}
      </ol>
    </div>
  );
}
